module.exports = __webpack_public_path__ + "45be0a74f8ae52646aefdedf97ee3379.png";